<div
  class="font-ms flex h-full w-full select-none flex-col rounded px-5 text-base"
  [ngClass]="{
    'border-s3 bg-s200 border': isKeepBackgroundColor === false,
    'text-s500': isKeepBackgroundColor === true
  }"
>
  <div class="pt-1">
    <table>
      <tbody class="divide-s300 divide-y">
        <tr
          *ngFor="let filter of proFilters; let filterIndex = index"
          class="group-link"
        >
          <td class="pb-2 pt-1 align-top">
            <div class="flex flex-col items-start justify-start">
              <div class="flex flex-row items-center">
                <div
                  *ngIf="!!listen"
                  class="text-s500 mr-2 flex flex-shrink-0 flex-row items-center space-x-5"
                >
                  <m-link-icon
                    *ngIf="!!listen[filter.fieldId] === true"
                    tp="Listens to dashboard filter {{
                      listen[filter.fieldId].split('_').join(' ')
                        | capitalizeWords
                    }}"
                  ></m-link-icon>

                  <m-link-off-icon
                    *ngIf="!!listen[filter.fieldId] === false"
                    tp="Does not listen to dashboard filter"
                  ></m-link-off-icon>
                </div>

                <m-field-label
                  [column]="filter.field"
                  class="flex text-sm"
                ></m-field-label>

                <div
                  *ngIf="!!deleteFilterFn"
                  class="invisible ml-5 [.group-link:hover_&]:visible"
                  tp="A required filter cannot be removed"
                  [tpIsEnabled]="filter.field.required === true"
                >
                  <button
                    class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                    [ngClass]="{
                      'hover:text-m500 text-s500':
                        filter.field.required === false,
                      'text-s400 cursor-default': filter.field.required === true
                    }"
                    [disabled]="filter.field.required === true"
                    (click)="deleteFilter(filter)"
                  >
                    <m-trash-icon></m-trash-icon>
                  </button>
                </div>
              </div> </div
          ></td>

          <td class="pb-1 pt-[2px] align-top">
            <div
              class="ml-5 flex flex-row items-start justify-start"
              *ngFor="
                let fraction of filter.fractions;
                let isFirst = first;
                let fractionIndex = index
              "
            >
              <div
                class="flex flex-shrink-0"
                [ngClass]="{
                  'mr-5 w-9': filter.fractions.length > 1
                }"
              >
                <div *ngIf="isFirst === true"></div>
                <div *ngIf="isFirst === false">
                  {{
                    fraction.operator === fractionOperatorEnum.Or
                      ? 'OR'
                      : !isFirst &&
                          fraction.operator === fractionOperatorEnum.And
                        ? 'AND'
                        : ''
                  }}
                </div>
              </div>
              <div
                *ngIf="!!fraction.brick"
                class="flex max-w-[450px] flex-shrink-0 pr-5"
                >{{
                  (fraction.parentBrick === 'f``'
                    ? 'any value'
                    : fraction.parentBrick?.slice(2, -1)) ?? fraction.brick
                    | capitalizeDow
                }}</div
              >

              <div
                *ngIf="!fraction.brick"
                class="flex max-w-[450px] flex-shrink-0 pr-5"
              >
                <div
                  *ngIf="!!fraction.storeFractionSubType"
                  class="flex max-w-[450px] flex-shrink-0 pr-5"
                >
                  <!-- <div> Type</div> -->
                  <div>
                    {{
                      fraction.storeFractionSubTypeLabel ||
                        fraction.storeFractionSubType
                    }}</div
                  >

                  <div
                    class="ml-5 flex flex-row items-start justify-start"
                    *ngFor="let control of fraction.controls"
                  >
                    <!-- <div>{{ control.name }}</div> -->
                    <div>{{ control.value }}</div>
                  </div>
                </div>

                <div
                  *ngIf="!fraction.storeFractionSubType"
                  class="flex max-w-[450px] flex-shrink-0 flex-col pr-5"
                >
                  <div
                    class="flex flex-row items-start justify-start"
                    *ngFor="let control of fraction.controls"
                  >
                    <div>{{ control.label || control.name }}</div>
                    <div class="ml-5">{{
                      control.controlClass === controlClassDatePicker &&
                      control.value.split('$METRICS_DATE_FROM').length > 1
                        ? metricsStartDateYYYYMMDD
                        : control.controlClass === controlClassDatePicker &&
                            control.value.split('$METRICS_DATE_TO').length > 1
                          ? getMetricsEndDateYYYYMMDD(filter.field.store)
                          : control.value
                    }}</div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
